// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Warning = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 24 24"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path d="M11.09 18.217h2.042v-2.06H11.09v2.06zM11 6l.162 8.995h1.773L13.132 6H11zm1 15c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9m0-19C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2" />
  </svg>
);
